module.exports = __webpack_public_path__ + "static/media/d12.33bd8800.gif";